// Full size
const notFound = require('../../assets/images/characters/not-found.svg');
const Ackbar = require('../../assets/images/characters/ackbar.jpg');
const ArvelCrynyd = require('../../assets/images/characters/arvel-crynyd.jpg');
const BeruWhitesunLars = require('../../assets/images/characters/beru-whitesun-lars.jpg');
const BibFortuna = require('../../assets/images/characters/bib-fortuna.jpg');
const BobaFett = require('../../assets/images/characters/boba-fett.jpg');
const C3po = require('../../assets/images/characters/c-3po.jpg');
const Chewbacca = require('../../assets/images/characters/chewbacca.jpg');
const DarthVader = require('../../assets/images/characters/darth-vader.jpg');
const HanSolo = require('../../assets/images/characters/han-solo.jpg');
const JabbaDesilijicTiure = require('../../assets/images/characters/jabba-desilijic-tiure.jpg');
const LandoCalrissian = require('../../assets/images/characters/lando-calrissian.jpg');
const LeiaOrgana = require('../../assets/images/characters/leia-organa.jpg');
const LukeSkywalker = require('../../assets/images/characters/luke-skywalker.jpg');
const MonMothma = require('../../assets/images/characters/mon-mothma.jpg');
const NienNunb = require('../../assets/images/characters/nien-nunb.jpg');
const ObiWanKenobi = require('../../assets/images/characters/obi-wan-kenobi.jpg');
const OwenLars = require('../../assets/images/characters/owen-lars.jpg');
const Palpatine = require('../../assets/images/characters/palpatine.jpg');
const R2D2 = require('../../assets/images/characters/r2-d2.jpg');
const R5D4 = require('../../assets/images/characters/r5-d4.jpg');
const WedgeAntilles = require('../../assets/images/characters/wedge-antilles.jpg');
const WicketSystriWarrick = require('../../assets/images/characters/wicket-systri-warrick.jpg');
const Yoda = require('../../assets/images/characters/yoda.jpg');

// Thumbnails
const notFoundThumbnail = require('../../assets/images/characters/thumbnails/not-found.svg');
const AckbarThumbnail = require('../../assets/images/characters/thumbnails/ackbar.jpg');
const ArvelCrynydThumbnail = require('../../assets/images/characters/thumbnails/arvel-crynyd.jpg');
const BeruWhitesunLarsThumbnail = require('../../assets/images/characters/thumbnails/beru-whitesun-lars.jpg');
const BibFortunaThumbnail = require('../../assets/images/characters/thumbnails/bib-fortuna.jpg');
const BobaFettThumbnail = require('../../assets/images/characters/thumbnails/boba-fett.jpg');
const C3poThumbnail = require('../../assets/images/characters/thumbnails/c-3po.jpg');
const ChewbaccaThumbnail = require('../../assets/images/characters/thumbnails/chewbacca.jpg');
const DarthVaderThumbnail = require('../../assets/images/characters/thumbnails/darth-vader.jpg');
const HanSoloThumbnail = require('../../assets/images/characters/thumbnails/han-solo.jpg');
const JabbaDesilijicTiureThumbnail = require('../../assets/images/characters/thumbnails/jabba-desilijic-tiure.jpg');
const LandoCalrissianThumbnail = require('../../assets/images/characters/thumbnails/lando-calrissian.jpg');
const LeiaOrganaThumbnail = require('../../assets/images/characters/thumbnails/leia-organa.jpg');
const LukeSkywalkerThumbnail = require('../../assets/images/characters/thumbnails/luke-skywalker.jpg');
const MonMothmaThumbnail = require('../../assets/images/characters/thumbnails/mon-mothma.jpg');
const NienNunbThumbnail = require('../../assets/images/characters/thumbnails/nien-nunb.jpg');
const ObiWanKenobiThumbnail = require('../../assets/images/characters/thumbnails/obi-wan-kenobi.jpg');
const OwenLarsThumbnail = require('../../assets/images/characters/thumbnails/owen-lars.jpg');
const PalpatineThumbnail = require('../../assets/images/characters/thumbnails/palpatine.jpg');
const R2D2Thumbnail = require('../../assets/images/characters/thumbnails/r2-d2.jpg');
const R5D4Thumbnail = require('../../assets/images/characters/thumbnails/r5-d4.jpg');
const WedgeAntillesThumbnail = require('../../assets/images/characters/thumbnails/wedge-antilles.jpg');
const WicketSystriWarrickThumbnail = require('../../assets/images/characters/thumbnails/wicket-systri-warrick.jpg');
const YodaThumbnail = require('../../assets/images/characters/thumbnails/yoda.jpg');

module.exports = {
  notFound,
  Ackbar,
  ArvelCrynyd,
  BeruWhitesunLars,
  BibFortuna,
  BobaFett,
  C3po,
  Chewbacca,
  DarthVader,
  HanSolo,
  JabbaDesilijicTiure,
  LandoCalrissian,
  LeiaOrgana,
  LukeSkywalker,
  MonMothma,
  NienNunb,
  ObiWanKenobi,
  OwenLars,
  Palpatine,
  R2D2,
  R5D4,
  WedgeAntilles,
  WicketSystriWarrick,
  Yoda,
  thumbnails: {
    notFound: notFoundThumbnail,
    Ackbar: AckbarThumbnail,
    ArvelCrynyd: ArvelCrynydThumbnail,
    BeruWhitesunLars: BeruWhitesunLarsThumbnail,
    BibFortuna: BibFortunaThumbnail,
    BobaFett: BobaFettThumbnail,
    C3po: C3poThumbnail,
    Chewbacca: ChewbaccaThumbnail,
    DarthVader: DarthVaderThumbnail,
    HanSolo: HanSoloThumbnail,
    JabbaDesilijicTiure: JabbaDesilijicTiureThumbnail,
    LandoCalrissian: LandoCalrissianThumbnail,
    LeiaOrgana: LeiaOrganaThumbnail,
    LukeSkywalker: LukeSkywalkerThumbnail,
    MonMothma: MonMothmaThumbnail,
    NienNunb: NienNunbThumbnail,
    ObiWanKenobi: ObiWanKenobiThumbnail,
    OwenLars: OwenLarsThumbnail,
    Palpatine: PalpatineThumbnail,
    R2D2: R2D2Thumbnail,
    R5D4: R5D4Thumbnail,
    WedgeAntilles: WedgeAntillesThumbnail,
    WicketSystriWarrick: WicketSystriWarrickThumbnail,
    Yoda: YodaThumbnail,
  },
};
